import { Button, Form, InputNumber } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

const StepperInput = ({
  min = 0,
  max = 10,
  step = 1,
  width = "w-10",
  height = "h-8",
  name,
  rules,
  onChange, // Add this prop to manually handle changes
  ...formItemProps
}) => {
  const form = Form.useFormInstance();
  const value = Form.useWatch(name, form);

  const handleChange = (newValue, action) => {
    if (newValue === null || isNaN(newValue)) return;

    let finalValue;
    if (action === "increment") {
      finalValue = Math.min(Number(value || min) + step, max);
    } else if (action === "decrement") {
      finalValue = Math.max(Number(value || min) - step, min);
    } else {
      finalValue = Math.min(Math.max(newValue, min), max);
    }

    // 1. Update the form value
    form.setFieldsValue({ [name]: finalValue });

    // 2. Manually mark the field as touched
    form.setFields([
      {
        name,
        touched: true,
        value: finalValue
      }
    ]);

    // 3. Manually trigger validation
    form.validateFields([name]);

    // 4. Call custom onChange if provided
    if (onChange) {
      onChange(finalValue);
    }
  };

  return (
    <Form.Item name={name} rules={rules} {...formItemProps}>
      <div className="flex items-center">
        <Button
          onClick={() => handleChange(0, "decrement")}
          shape="circle"
          size="small"
          className="bg-[#E5E7EB] hover:!bg-[#E5E7EB] border-none"
          disabled={value <= min}
          icon={<MinusOutlined className="text-white !text-md font-bold" />}
        />

        <InputNumber
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(val) => handleChange(val)}
          onBlur={() => form.setFields([{ name, touched: true }])}
          className={`${width} ${height} [&_.ant-input-number-input]:text-center bg-transparent border-0 text-[#000929] font-manropeBold font-semibold text-base !p-0 focus:!border-0 focus:!shadow-none focus-within:!border-transparent focus-within:!shadow-none`}
          controls={false}
        />

        <Button
          onClick={() => handleChange(0, "increment")}
          shape="circle"
          size="small"
          className="bg-primary hover:!bg-primary border-none"
          disabled={value >= max}
          icon={<PlusOutlined className="text-white !text-lg font-bold" />}
        />
      </div>
    </Form.Item>
  );
};

export default StepperInput;
